import { createElement as h } from "react"

import { Button as MuiButton } from "@mui/material"
import T from "prop-types"
import { equals, not, prop } from "ramda"
import { cx } from "ramda-extension/es"

import { Data } from "@cirrus/fe-lib"

import { useDynamicOverrides, useOverrides } from "./css"
import { GUIElement } from "../../../lib/_public"
import { Progress } from "../../atoms"

export const Button = ({
  background,
  backgroundOnHover,
  color = "secondary",
  disableElevation = true,
  fontColor,
  height,
  label,
  pending = false,
  variant,
  width,
  padding = [0, 24],
  hoverStyle,
  ...props
}) => {
  const normalizedColor = color === "default" ? "secondary" : color
  const staticOverrides = useOverrides(),
    dynamicOverrides = useDynamicOverrides({
      background,
      backgroundOnHover,
      color: normalizedColor,
      fontColor,
      height,
      hoverStyle,
      padding,
      pending,
      width,
    })

  return h(
    MuiButton,
    Data.merged(props, {
      classes: {
        // TODO: Automate this
        contained: cx(prop("contained", staticOverrides), prop("contained", dynamicOverrides)),
        disabled: cx(prop("disabled", staticOverrides), prop("disabled", dynamicOverrides)),
        outlined: cx(prop("outlined", staticOverrides), prop("outlined", dynamicOverrides)),
        root: cx(prop("root", staticOverrides), prop("root", dynamicOverrides)),
        text: cx(prop("text", staticOverrides), prop("text", dynamicOverrides)),
      },

      disableElevation,
      title: label,
      variant,
    }),

    GUIElement.withPlaceholder({
      content: ["span", null, label],
      displayed: not(pending),
      placeholder: [
        Progress.Circular,
        {
          color: normalizedColor,
          shade: equals(variant, "outlined") ? null : "contrastText",
          size: 26,
        },
      ],
    }),
  )
}

Button.propTypes = {
  background: T.string,
  backgroundOnHover: T.string,
  className: T.string,
  color: T.string,
  disableElevation: T.bool,
  disabled: T.bool,
  endIcon: T.element,

  /** Custom font color for the button with `variant="contained"` or `variant="outlined"` */
  fontColor: T.string,

  height: T.oneOfType([T.string, T.number]),
  label: T.string,
  hoverStyle: T.oneOf(["default", "always", "never"]),
  onClick: T.func,
  padding: T.arrayOf(T.oneOfType([T.number, T.string])),
  pending: T.bool,
  startIcon: T.element,
  variant: T.oneOf(["contained", "outlined", "text", "legacy"]),
  width: T.oneOfType([T.string, T.number]),
}
